import { createContext, Dispatch, SetStateAction } from 'react';

type AuthContext = {
  currentUser: any;
  loginError: any;
  setLoginError: Dispatch<SetStateAction<any>>;
  enrolledFactors: any[];
  auth: any;
  accessToken: string;
  setAccessToken: Dispatch<SetStateAction<string>>;
  loginRequired: boolean;
  setLoginRequired: Dispatch<SetStateAction<boolean>>;
};

const AuthContext = createContext<AuthContext>({
  currentUser: undefined,
  loginError: undefined,
  setLoginError: () => {},
  enrolledFactors: [],
  auth: undefined,
  accessToken: '',
  setAccessToken: () => {},
  loginRequired: false,
  setLoginRequired: () => {},
});

export default AuthContext;
